export default __webpack_public_path__ + "assets/images/provably-fair-fd1bfd8a9a4edc22a9860394ece894b2.svg";